<template>
  <h2 class="pb-2 border-bottom">Wellness & Hydration</h2>
  <ul>
    <li>Hydration IV – Electrolytes & fluids for dehydration recovery</li>
    <li>Immunity Boost IV – Vitamin C, zinc, and glutathione for immune support</li>
    <li>Detox IV – Glutathione, antioxidants, and fluids to flush out toxins</li>
  </ul>

  <h2 class="pb-2 border-bottom">Energy & Performance Enhancement</h2>
  <ul>
    <li>Myers’ Cocktail – Magnesium, calcium, B vitamins, and vitamin C for energy and wellness</li>
    <li>Athlete Recovery IV – Amino acids, B12, and hydration for muscle recovery</li>
    <li>B12 Energy Boost IV – Vitamin B12 to improve energy and metabolism</li>
  </ul>

  <h2 class="pb-2 border-bottom">Beauty & Anti-Aging</h2>
  <ul>
    <li>Glow IV – Biotin, vitamin C, and glutathione for skin, hair, and nail health</li>
    <li>Anti-Aging IV – NAD+, glutathione, and collagen-boosting nutrients</li>
  </ul>

  <h2 class="pb-2 border-bottom">Weight Loss & Metabolism</h2>
  <ul>
    <li>Fat Burner IV – L-carnitine, MIC (Methionine, Inositol, Choline), and B vitamins for metabolism boost</li>
    <li>Metabolic Reset IV – Amino acids, vitamin B complex, and hydration for weight management</li>
  </ul>

  <h2 class="pb-2 border-bottom">Recovery & Hangover Relief</h2>
  <ul>
    <li>Hangover Recovery IV – Electrolytes, B vitamins, and anti-nausea medication</li>
    <li>Migraine & Stress Relief IV – Magnesium, B vitamins, and hydration for headache relief</li>
  </ul>
</template>

<script>
export default {
  name: 'IMIVVitaminTherapiesContentEn'
};
</script>

<style scoped>
/* Add any component-specific styles here */
</style>
